import { render } from "./AffiliationsListPage.vue?vue&type=template&id=85d5e73e&scoped=true&ts=true"
import script from "./AffiliationsListPage.vue?vue&type=script&lang=ts"
export * from "./AffiliationsListPage.vue?vue&type=script&lang=ts"

import "./AffiliationsListPage.vue?vue&type=style&index=0&id=85d5e73e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85d5e73e"]])

export default __exports__